const isProduction = process.env.NODE_ENV === 'production'

const initiateRRProd = () => {
  var RR_APP_ID = 'tpqxZq0ZmkJoOqG1olL9'
  window.RetainRocket = null
  ;(function (r, aa, f, t, dot, i, o) {
    r[dot] =
      r[dot] ||
      function () {
        ;(r[dot].q = r[dot].q || []).push(arguments)
      }
    r[dot].l = 1 * new Date()
    i = aa.createElement(f)
    o = aa.getElementsByTagName(f)[0]
    i.id = 'RetainRocketScript'
    i.async = 1
    i.src = t
    o.parentNode.insertBefore(i, o)
  })(
    window,
    document,
    'script',
    'https://widget.retainrocket.com/widget.js?appId=' + RR_APP_ID,
    'rr'
  )
}

const initiateRRStaging = () => {
  var RR_APP_ID = 'tpqxZq0ZmkJoOqG1olL9'
  window.RetainRocket = null
  ;(function (r, aa, f, t, dot, i, o) {
    r[dot] =
      r[dot] ||
      function () {
        ;(r[dot].q = r[dot].q || []).push(arguments)
      }
    r[dot].l = 1 * new Date()
    i = aa.createElement(f)
    o = aa.getElementsByTagName(f)[0]
    i.id = 'RetainRocketScript'
    i.async = 1
    i.src = t
    o.parentNode.insertBefore(i, o)
  })(
    window,
    document,
    'script',
    'https://staging.widget.retainrocket.com/widget.js?appId=' + RR_APP_ID,
    'rr'
  )
}

const initiateRR = isProduction ? initiateRRProd : initiateRRStaging

export default initiateRR
